import { post, get } from '@/utils/request'
import { php_post } from '@/utils/php_request'

/**
 * 获取用户信息
 * @param {Object} data
 * {userToken:'',currentPageNumber:'',numberOfImpressions:''},
 */
export function getUserInfo (data) {
  return get('/miniapps/user/userCenterQuery', data)
}

/**
 * 获取用户地址列表
 * @param {Object} data
 * {userToken;''}
 */
export function getAddressList (data) {
  return get('/miniapps/addressManagement/selectAddressList', data)
}

/**
 * 地址管理--编辑
 * editType 1：新增 2：修改 3：删除 4：默认地址修改
 * @param {Object} data
 * {addressId:'',userToken:'',provinceId:'',cityId:'',areaId:'',connection:'',detailedAddress:'',tel:'',receiver:'',defaultAddress:'':editType:''},
 */
export function postAddressEdit (data) {
  return post('/miniapps/addressManagement/addressEditing', data)
}

/**
 * 用户服务消息列表
 * @param {Object} data
 * {userToken:'',currentPageNumber:'',numberOfImpressions:''},
 */
export function getMessageList (data) {
  return post('/miniapps/sysmsg/selectUserSysmsgList', data)
}

/**
 * 用户服务消息--已读
 * @param {Object} data
 * {userToken:''},
 */
export function postEessageEdit (data) {
  return get('/miniapps/sysmsg/updateUserSysmsgSta', data)
}
/**
 * 用户付款优惠券查询
 * @param {Object} data
 * {userToken:'',scopeOfUse:'',orderCommodityIds:''},
 */
export function getCouponList (data) {
  return post('/miniapps/privilege/selectOrderPrivilegeList', data)
}

// /**
//  * 上传图片
//  * @param {Object} data
//  * {file:'',useChannel:'Test'},
//  */
// export function UploadImg (data) {
//   return post('/miniapps/common/uploadPicture', data)
// }
/**
 * 默认省市区
 * @param {Object}
 */
export function initAreaList () {
  return get('/miniapps/addressManagement/selectCityAll')
}
/**
 * 获取省市区
 * @param {Object}
 */
export function getAreaList () {
  return get('/miniapps/addressManagement/selectCityWithChildren')
}
/**
 * 获取默认收货地址
 * @param {Object} data
 * {userToken:'',addressId:''},
 */
export function getDefaultAddress (data) {
  return post('/miniapps/addressManagement/selectUserAddressDetails', data)
}
/**
 * 获取默认收货地址
 */
export function getStoreAddress () {
  return get('/miniapps/addressManagement/selectSelfLiftingAddress')
}

/**
 * 获取用户银行卡信息
 * @param {Object} data
 */
 export function getUserCard() {
  return php_post('/Myaccount/getUserCardlist')
}
/**
 * 获取用户资金明细
 * @param {Object} data
 */
 export function getUserMoney(data) {
  return php_post('/Myaccount/moneyDetail', data)
}
/**
 * 用户提现
 * @param {Object} data
 */
 export function userCash(data) {
  return php_post('/Myaccount/cash', data)
}